import http from "../../services/httpService";
import { error, isEmpty } from "../common/global";

const props = {
    discountConfigurationMarker: '#marker-discount-configuration',
    voucherCodeField: '#voucher-code',
    applyVoucherCode: '#apply-voucher',
    voucherCodeErrorWrapper: '#voucher-application-error-wrapper',
    removeVoucherCode: '#remove-voucher',
    voucherConditionsDisplayLink: '#show-vouchers-conditions',
    voucherConditionsWrapper: '#show-vouchers-wrapper'
};

export function initDiscountConfiguration() {

    if ($(props.discountConfigurationMarker).length) {

        bindApplyVoucherCode();

        bindRemoveVoucherCode();

        bindVoucherConditionsDisplay();
    }
}


async function bindApplyVoucherCode() {

    $(props.applyVoucherCode).off('click').on('click', async function () {

        //load category picker 
        const data = {
            voucherCode: $(props.voucherCodeField).val()
        };

        const result = await applyVoucherService(data);

        if (result.responseType === "SUCCESS") {

            //reload page
            window.location.href = window.location.href;
        }
        else {

            //display error panel
            $(props.voucherCodeErrorWrapper).html(result.responseMessage);

            $(props.voucherCodeErrorWrapper).show();
        }
    });

    $(props.voucherCodeField).off('keyup').on('keyup', function (e) {

        if (e.keyCode === 13) {
            $(props.applyVoucherCode).click();
        }
    });
}

async function bindRemoveVoucherCode() {

    $(props.removeVoucherCode).off('click').on('click', async function () {

        //load category picker 
        const data = {
            voucherCode: $(this).data('code')
        };

        const result = await removeVoucherService(data);

        if (result.responseType === "SUCCESS") {

            //reload page
            window.location.href = window.location.href;
        }
        else {

            //display error panel
            $(props.voucherCodeErrorWrapper).html(result.responseMessage);

            $(props.voucherCodeErrorWrapper).show();
        }
    });
}

function bindVoucherConditionsDisplay() {

    $(props.voucherConditionsDisplayLink).off('click').on('click', async function () {

        if ($(props.voucherConditionsWrapper).is(":visible")) {

            $(props.voucherConditionsWrapper).hide(500);
        }
        else {

            $(props.voucherConditionsWrapper).show(500);
        }

    });

}

//API CALLS

async function applyVoucherService(data) {

    const response = await http.post('/checkout/applyvoucher', data, true);
    // The response is an object with a property called 'data'. 
    return response.data;
}

async function removeVoucherService(data) {

    const response = await http.post('checkout/removevoucher', data, true);
    // The response is an object with a property called 'data'. 
    return response.data;
}
